import { registerEnumType } from 'type-graphql'

export enum ReturnOrderStatusEnum {
  Draft = 'Draft',
  Confirmed = 'Confirmed',
}

registerEnumType(ReturnOrderStatusEnum, {
  name: 'ReturnOrderStatusEnum',
  description: 'Lifecycle status of a return order.',
})
